import { useEffect, useState } from "react";
import "./live.css";

const REACTION_EMOJIS = {
  like: "👍",
  love: "❤️",
  haha: "😂",
  wow: "😮",
  sad: "😢",
  angry: "😠",
};

export default function FloatingReactions({ reactions }) {
  const [visibleReactions, setVisibleReactions] = useState([]);

  useEffect(() => {
    if (reactions && reactions.length > 0) {
      setVisibleReactions((prev) => [...prev, ...reactions]);

      // Remover reações antigas após animação
      const timer = setTimeout(() => {
        setVisibleReactions((prev) =>
          prev.filter((r) => Date.now() - r.id < 3000)
        );
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [reactions]);

  return (
    <div className="floating_reactions_container">
      {visibleReactions.map((reaction) => (
        <div
          key={reaction.id}
          className="floating_reaction"
          style={{
            left: `${Math.random() * 80 + 10}%`,
            animationDelay: `${Math.random() * 0.3}s`,
          }}
        >
          <span className="reaction_emoji">
            {REACTION_EMOJIS[reaction.reaction] || "👍"}
          </span>
        </div>
      ))}
    </div>
  );
}

// Botões de reação para enviar
export function ReactionButtons({ onReact, disabled }) {
  const reactions = ["like", "love", "haha", "wow", "sad", "angry"];

  return (
    <div className="reaction_buttons">
      {reactions.map((reaction) => (
        <button
          key={reaction}
          className="reaction_btn"
          onClick={() => onReact(reaction)}
          disabled={disabled}
          title={reaction}
        >
          {REACTION_EMOJIS[reaction]}
        </button>
      ))}
    </div>
  );
}
